import { render } from "./App.vue?vue&type=template&id=480badb5&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=480badb5&lang=css"

import exportComponent from "/home/runner/work/binity-order/binity-order/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__